
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import AuthGroup from '@/logic/auth/AuthGroup';
import { Languages } from '@/logic/locale/Languages';

@Component
export default class LocaleField extends Vue {
  @Prop({ default: '' })
  value!: string;

  @Prop(String)
  group!: AuthGroup | undefined;

  @Emit()
  input(value: string) {
    return value;
  }

  get isLocalised(): boolean {
    // If group property is given, this is the add user form, so
    // we should localise
    return this.group !== undefined;
  }

  get isIndirect(): boolean {
    if (this.$store.getters['auth/memberOf'](AuthGroup.Indirect)) {
      return true;
    }

    return this.group === AuthGroup.Indirect;
  }

  get locales(): any[] {
    const locales = this.isIndirect
      ? ['en-GB', 'it']
      : ['de', 'en-GB', 'es', 'fr', 'it', 'nl'];

    if (this.isLocalised) {
      return locales.map((loc) => ({
        value: loc,
        label: this.$t(`general.locale.${loc}`),
      }));
    }

    return locales.map((loc) => ({
      value: loc,
      label: this.unlocalisedLabel(loc),
    }));
  }

  unlocalisedLabel(loc: string): string {
    const lang = Languages.getLanguageById(loc);
    return lang !== undefined
      ? lang.label
      : (this.$t(`general.locale.${loc}`) as string);
  }
}
